module.exports = __webpack_public_path__ + "media/icons/times_white-d75c1a68.svg";